import React, { Component } from 'react';

export default class Modal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			name: this.props.modal && this.props.modal.name ? this.props.modal.name : ''
		}

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState(state => {
			state.name = nextProps.modal && nextProps.modal.name ? nextProps.modal.name : '';
			return state;
		});
	}

	handleInputChange(event) {
		this.setState({ name: event.target.value });
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.handleEditTally(
			this.props.selectedTally ? 'EDIT' : 'NEW', {
				name: this.state.name || 'Untitled Tally',
				setId: this.props.selectedSet,
				tallyId: this.props.selectedTally
			}
		);
	}

	render() {
		return (
			<div className="MODAL">
				<form onSubmit={this.handleSubmit}>
					<input className="input" name="name" type="text" value={this.state.name} onChange={this.handleInputChange} placeholder="Tally Name" />
					<button className="button alt-confirm" type="submit">{this.props.selectedTally ? 'Save' : 'Add Tally'}</button>
					<label htmlFor="modal-toggle" className="button alt-cancel">Cancel</label>
				</form>
			</div>
		);
	}
};


// WEBPACK FOOTER //
// ./src/modals/edit-tally.js